/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/core";

import React from "react";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { useWindowWidth } from "@react-hook/window-size";

// import logo_for_light_theme from ":/assets/img/homepage/logo-for-light-theme.png";
// import logo_for_dark_theme from ":/assets/img/homepage/logo-for-dark-theme.png";

import { BsJournalCode } from "react-icons/bs";
import { IoSparkles } from "react-icons/io5";
import { FaDiscord } from "react-icons/fa";

export default function Footer(props) {
  const windowWidth = useWindowWidth();

  const year = new Date().getFullYear();
  return (
    <div className={`Footer ${props.className}`} css={CSS}>
      <div className="page-container">
        <div className="sides">
          <div className="left">
            <div className="logo">
              <Link to={"/"}>
                <img
                  className="light-theme-only text"
                  // src={logo_for_light_theme}
                  alt=""
                />
                <img
                  className="dark-theme-only text"
                  // src={logo_for_dark_theme}
                  alt=""
                />
              </Link>
            </div>
            <div className="about"></div>
          </div>
          <div className="right">
            <div className="links">
              {/* <a href={process.env.REACT_APP_DISCORD_INVITE}>
                {" "}
                <FaDiscord className="icon" /> Chat with us
              </a>
              <a href="/">Docs</a>
              <a href={`https://twitter.com/${process.env.REACT_APP_TWITTER_HANDLE}`}>Twitter</a> */}
            </div>
          </div>
        </div>
        <div className="built-with"></div>
      </div>
      <div className="define-the-possible-container">
        <div className="marquee-horizontal">
          <div className="track-horizontal">
            {[
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
              20,
            ].map((i) => (
              <div className="text" key={i}>
                <BsJournalCode /> Define the Possible.
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

const CSS = css`
  background: #000;
  .page-container {
  }
  .left {
    width: 300px;
    margin: 0 auto;
  }
  .built-with {
    text-align: center;
  }
  @media (min-width: 600px) {
    .sides {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 800px;
      max-width: 100%;
      margin: 0px auto;
      margin-bottom: 30px;
    }
    flex-wrap: wrap;
    .left {
      width: auto;
      margin: 0;
      -flex-basis: 50%;
    }
    .right {
      -flex-basis: 50%;
    }
    .built-with {
      flex-basis: 100%;
    }
  }
  .logo {
    width: 100px;
  }
  .about {
    text-align: left;
    padding: 20px 0;
    line-height: 1.2em;
    max-width: 200px;
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
  }
  .links {
    a {
      background: #bebebe3b;
      width: 300px;
      max-width: 100%;
      display: block;
      margin: 10px auto;
      padding: 16px 20px;
      border-radius: 20px;
      text-transform: uppercase;
      font-weight: bold;
    }
  }
  .define-the-possible-container {
    background-color: #000;
    padding: 20px 0;
    .marquee-horizontal {
      position: relative;
      z-index: 200;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      overflow: hidden;
      width: 100%;
      height: 40px;
      -webkit-box-pack: start;
      -webkit-justify-content: flex-start;
      -ms-flex-pack: start;
      justify-content: flex-start;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      border-style: solid none;
      border-color: #fff;
      background-color: transparent;
    }
    .track-horizontal {
      position: absolute;
      white-space: nowrap;
      will-change: transform;
      animation: marquee-horizontal 120s linear infinite;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .text {
      color: #fff6e8;
      display: flex;
      align-content: center;
      flex-direction: row;
      align-items: center;
      svg {
        display: inline-block;
        padding: 5px;
        margin-right: 20px;
      }
      padding: 0 20px;
      font-size: 36px;
    }
  }
  // dark-theme or override
  body.dark-theme &,
  &.dark-theme {
    color: white;
    background: #1f2027;
    .links {
      a {
        color: white;
      }
    }
    .about {
      color: #ccc;
    }
    .built-with {
      color: gray;
    }
  }
`;
